import { useQuery } from "@tanstack/react-query";
import { queryClient } from "shared/api/queryClient";
import { getThemePrimaryTags } from "../api/getThemePrimaryTags";

const THEME_PRIMARY_TAG_LIST_QUERY_KEY = "themePrimaryTagList";

export const useThemePrimaryTagsQuery = () => {
  return useQuery({
    queryKey: [THEME_PRIMARY_TAG_LIST_QUERY_KEY],
    queryFn: getThemePrimaryTags,
  });
};

export const invalidateThemePrimaryTagsQuery = () => {
  return queryClient.invalidateQueries({
    queryKey: [THEME_PRIMARY_TAG_LIST_QUERY_KEY],
  });
};
